import { ITEMS_TYPES } from "./constants";
import { routes } from "routes";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { hideAllMenus } from "store/application/application-action";
import { nFormatter } from "utils/parseNumber";
import { useQuery } from "hooks/useQuery";
import { IHistoryList, INichesItems, ICreatorsItems } from "services/types";

import "./styles/SearchResultItem.scss";

interface ISearchResultItemProps {
  itemType: string;
  itemData: IHistoryList | INichesItems | ICreatorsItems;
  setSearchInput: (arg: string) => void;
  setCurrentTag: (arg: string[]) => void;
}

export const SearchResultItem = ({ itemType, itemData, setSearchInput, setCurrentTag }: ISearchResultItemProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const query = useQuery();

  const isNicheItem = (item: IHistoryList | INichesItems | ICreatorsItems): item is INichesItems => {
    return (item as INichesItems).id !== undefined;
  };

  const isPersonItem = (item: IHistoryList | INichesItems | ICreatorsItems): item is ICreatorsItems => {
    return (item as ICreatorsItems).verified !== undefined;
  };

  const handleClickSearchItem = () => {
    setSearchInput("");

    if (isNicheItem(itemData)) {
      navigate(routes.niche(itemData.id));
    } else if (isPersonItem(itemData)) {
      navigate(routes.user(itemData.text.substr(1)));
    } else {
      // @ts-ignore
      setCurrentTag(prev => {
        if (prev.includes(itemData.text)) {
          navigate(routes.multipleTag(prev, query.get("order") ?? undefined, !!query.get("verified")));
          return prev;
        }

        if (prev.length >= 3) {
          return prev;
        }

        navigate(routes.multipleTag([...prev, itemData.text], query.get("order") ?? undefined, !!query.get("verified")));
        return [...prev, itemData.text];
      });

    }
    document?.getElementById("global-search-input")?.blur();
    dispatch(hideAllMenus());
  };

  const renderIcon = () => {
    if (itemType === ITEMS_TYPES.isSavedItem) {
      return <div className="SearchResultItem-ClockIcon" />;
    }

    if (isPersonItem(itemData)) {
      return itemData.image ? (
        <div className="SearchResultItem-PersonIcon" style={{ backgroundImage: `url(${itemData.image})` }} />
      ) : (
        <div className="SearchResultItem-PersonIcon SearchResultItem-PersonIcon_isEmpty" />
      );
    }

    if (isNicheItem(itemData)) {
      return itemData.image ? (
        <div className="SearchResultItem-NicheIcon" style={{ backgroundImage: `url(${itemData.image})` }} />
      ) : (
        <div className="SearchResultItem-NicheIcon SearchResultItem-NicheIcon_isEmpty" />
      );
    }
  };

  const renderInfo = () => {
    if (itemType === ITEMS_TYPES.isSavedItem || isPersonItem(itemData)) {
      return (
        <div className="SearchResultItem-Cnt">
          <h4>
            {itemData.text}
            {isPersonItem(itemData) && itemData.verified && <span />}
          </h4>
        </div>
      );
    }

    if (isNicheItem(itemData)) {
      return (
        <div className="SearchResultItem-Cnt">
          <h4>{itemData.text}</h4>
          <p>Niche | {nFormatter(itemData.subscribers)} members</p>
        </div>
      );
    }
  };

  return (
    <li className="SearchResultItem" onClick={handleClickSearchItem}>
      { renderIcon() }
      { renderInfo() }
      <div className="SearchResultItem-Arrow"/>
    </li>
  );
};
